/** Temporary YouTube playlist-picker draft. Never a My Music record. */
export const MAX_PLAYLIST_SELECTION = 10;

export function emptyPlaylistSelection() {
  return new Set();
}

export function playlistSelectionCountLabel(
  count,
  limit = MAX_PLAYLIST_SELECTION,
) {
  const safe = Number.isSafeInteger(count) && count > 0 ? count : 0;
  return `${safe} of ${limit} selected`;
}

/**
 * Toggle one id in the draft. At the cap, an unchecked id is left unchanged
 * so an 11th playlist is never silently added.
 */
export function togglePlaylistSelection(
  selected,
  playlistId,
  { limit = MAX_PLAYLIST_SELECTION } = {},
) {
  const current = selected instanceof Set ? selected : new Set(selected || []);
  if (!playlistId) {
    return { selection: new Set(current), accepted: false, reason: 'missing-id' };
  }
  const next = new Set(current);
  if (next.has(playlistId)) {
    next.delete(playlistId);
    return { selection: next, accepted: true, reason: 'unchecked' };
  }
  if (next.size >= limit) {
    return { selection: next, accepted: false, reason: 'limit' };
  }
  next.add(playlistId);
  return { selection: next, accepted: true, reason: 'checked' };
}

export function isPlaylistSelectionDisabled(
  selected,
  playlistId,
  { limit = MAX_PLAYLIST_SELECTION } = {},
) {
  const current = selected instanceof Set ? selected : new Set(selected || []);
  if (!playlistId || current.has(playlistId)) return false;
  return current.size >= limit;
}

/**
 * Playlists to process at submit time. This is the current draft, not a
 * checkbox transition since the picker opened.
 */
export function playlistsForSubmission(visiblePlaylists, selectedIds) {
  const selected = selectedIds instanceof Set ? selectedIds : new Set(selectedIds || []);
  const seen = new Set();
  const targets = [];
  (visiblePlaylists || []).forEach((playlist) => {
    const playlistId = playlist?.playlistId;
    if (!playlistId || !selected.has(playlistId) || seen.has(playlistId)) return;
    seen.add(playlistId);
    targets.push(playlist);
  });
  return targets;
}

export function classifyPlaylistSubmission(visiblePlaylists, selectedIds, importedIds) {
  const imported = importedIds instanceof Set ? importedIds : new Set(importedIds || []);
  const targets = playlistsForSubmission(visiblePlaylists, selectedIds);
  return {
    targets,
    refresh: targets.filter((playlist) => imported.has(playlist.playlistId)),
    imports: targets.filter((playlist) => !imported.has(playlist.playlistId)),
  };
}
